export const CONFIGS = 'configs'
export const SET_CONFIGS = CONFIGS + '/SET_CONFIGS'
export const SET_ALLOWED_COUNTRIES = CONFIGS + '/SET_ALLOWED_COUNTRIES'
